import { AbsoluteFill, OffthreadVideo } from 'remotion';
import { CurrentEffect } from '../../types';

export const BrollEffectVideo: React.FC<{ data: CurrentEffect; id: string }> = ({ data, id }) => {
  if (!data.isVideo) return null;

  return (
    <AbsoluteFill key={id}>
      <OffthreadVideo
        muted
        style={{
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          mixBlendMode:
            (data?.selectedEffect?.blendStyle as React.CSSProperties['mixBlendMode']) || 'screen',
        }}
        onError={() => {}}
        pauseWhenBuffering={true}
        src={data.videoPath}
      />
    </AbsoluteFill>
  );
};
